import { useContext } from 'react';
import UserContext from 'modules/common/context/UserContext';
import { ADMIN_USER_GROUP } from 'modules/common/constants';

export function useIsAdminRole() {
  const { userGroups } = useContext(UserContext);

  return userGroups?.includes(ADMIN_USER_GROUP);
}
